import Button from '@mui/material/Button';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { _ } from '/@/locale';
import { getSessionLanguage } from '/@/store/session/selectors';
import { formatDate, toDegreesMinutesAndSeconds } from '/@/utils';
import { reverse } from '/@/utils/router';
import styles from './styles.module.css';

const getGoogleMapsUrl = (marker) => {
    return 'https://www.google.com/maps/search/?api=1&query=' + marker.latitude + ',' + marker.longitude;
};
@connect((state) => ({ language: getSessionLanguage(state) }))
@autobind
export default class RenderMarkerDescription extends Component {
    static propTypes = {
        marker: PropTypes.object.isRequired,
        onClose: PropTypes.func.isRequired,
        phenologiesOptions: PropTypes.array.isRequired,
    };

    static contextTypes = {
        history: PropTypes.object,
    };

    redirectToFieldDetail(field) {
        this.context.history(reverse('fields.FieldDetail', { params: { fieldId: field.id } }));
    }

    renderFieldDescription(field, onClose) {
        return (
            <div className={styles.description}>
                <div className={styles.close} onClick={onClose}>
                    <i className='material-icons'>close</i>
                </div>
                <div>
                    <div className={styles.title}>{_('Nombre')}</div>
                    <div className='mp-mask'>{field.name}</div>
                </div>
                <div>
                    <div className={styles.title}>{_('Ubicación')}</div>
                    <div className='mp-mask'>{field.location}</div>
                </div>
                <div className={styles.button}>
                    <Button variant='outlined' fullWidth onClick={() => this.redirectToFieldDetail(field)}>
                        {_('Ver más')}
                    </Button>
                </div>
            </div>
        );
    }

    renderTrialDescription(trial, onClose) {
        const phenologicalStage = this.props.phenologiesOptions.find(({ value }) => value === trial.phenologicalStage);
        return (
            <div className={styles.description}>
                <div className={styles.close} onClick={onClose}>
                    <i className='material-icons'>close</i>
                </div>
                <div>
                    <div className={styles.title}>{_('Nombre')}</div>
                    <div>{trial.name}</div>
                </div>
                <div>
                    <div className={styles.title}>{_('Tipo')}</div>
                    <div>{trial.type.name[this.props.language]}</div>
                </div>
                <div>
                    <div className={styles.title}>{_('Responsable')}</div>
                    <div>{trial.manager}</div>
                </div>
                <div>
                    <div className={styles.title}>{_('Contacto')}</div>
                    <div>{trial.contact}</div>
                </div>
                <div>
                    <div className={styles.title}>{_('Geoposición')}</div>
                    <div>
                        {_('Latitud')}: {toDegreesMinutesAndSeconds(trial.latitude)}
                    </div>
                    <div>
                        {_('Longitud')}: {toDegreesMinutesAndSeconds(trial.longitude)}
                    </div>
                </div>
                <div>
                    <div className={styles.title}>{_('Fecha de siembra')}</div>
                    <div>{trial.plantingDate ? formatDate(new Date(trial.plantingDate)) : '-'}</div>
                </div>
                <div>
                    <div className={styles.title}>{_('Estadio fenológico estimado')}</div>
                    <div>{_(phenologicalStage.label)}</div>
                </div>
                <hr />
                <div className={styles.disclaimer}>
                    {_(
                        '*Para lograr una cosecha de calidad, a partir de la madurez fisiológica el grano debe perder humedad. Esto dependerá de las condiciones climáticas de demanda atmosférica.'
                    )}
                </div>
                <hr />
                <div className={styles.disclaimer}>
                    {_('**La fenología de los ensayos se calcula tomando como referencia al híbrido DK72-10.')}
                </div>
                <div className={styles.button}>
                    <Button variant='outlined' fullWidth color='gray'>
                        <a href={getGoogleMapsUrl(trial)} target='_blank' rel='noreferrer'>
                            {_('Abrir en Google Maps')}
                        </a>
                    </Button>
                </div>
            </div>
        );
    }

    render() {
        const { marker, onClose } = this.props;
        return (
            <div>
                {marker.markerType === 'field'
                    ? this.renderFieldDescription(marker, onClose)
                    : this.renderTrialDescription(marker, onClose)}
            </div>
        );
    }
}
